import { render, staticRenderFns } from "./SystemNoticePage.vue?vue&type=template&id=0f9a81c3&scoped=true&"
import script from "./SystemNoticePage.vue?vue&type=script&lang=js&"
export * from "./SystemNoticePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a81c3",
  null
  
)

export default component.exports